import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Optional, Inject, Input, ViewChild, Output, NgModule } from '@angular/core';
import * as i2 from 'base-selecting-lca-soc-library';
import { BaseSelectingLcaSocLibraryService } from 'base-selecting-lca-soc-library';
import { first } from 'rxjs/internal/operators/first';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'dirty-check-store';
import * as i6 from 'cache-country-list';
import * as i7 from 'reference-library';
import * as i8 from 'primeng/dynamicdialog';
import * as i9 from '@angular/router';
import * as i10 from 'app-services-library';
import * as i11 from '@angular/forms';
import * as i12 from 'primeng/dropdown';
import * as i13 from 'primeng/api';
import * as i14 from '@angular/common';
import * as i15 from 'primeng/checkbox';
import * as i16 from 'primeng/divider';
import * as i17 from 'primeng/button';
import * as i18 from 'primeng/table';
import * as i19 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';

class SelectingLcaSocLibraryService {
    constructor() { }
}
SelectingLcaSocLibraryService.ɵfac = function SelectingLcaSocLibraryService_Factory(t) { return new (t || SelectingLcaSocLibraryService)(); };
SelectingLcaSocLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: SelectingLcaSocLibraryService, factory: SelectingLcaSocLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectingLcaSocLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["selectLCAForm"];
function SelectingLcaSocLibraryComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", item_r4.caseNumber, " - ", item_r4.notes, " ");
} }
function SelectingLcaSocLibraryComponent_div_20_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Case Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "SOC Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "SOC Job Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 24);
    i0.ɵɵtext(8, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 25);
    i0.ɵɵtext(10, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SelectingLcaSocLibraryComponent_div_20_ng_template_3_ng_container_8_b_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "b", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const getDoc_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(getDoc_r9.fileName);
} }
function SelectingLcaSocLibraryComponent_div_20_ng_template_3_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectingLcaSocLibraryComponent_div_20_ng_template_3_ng_container_8_b_1_Template, 2, 1, "b", 29);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const getDoc_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", getDoc_r9.fileCategory.code === "LCA");
} }
function SelectingLcaSocLibraryComponent_div_20_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 24);
    i0.ɵɵtemplate(8, SelectingLcaSocLibraryComponent_div_20_ng_template_3_ng_container_8_Template, 2, 1, "ng-container", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 25);
    i0.ɵɵelementStart(10, "button", 27);
    i0.ɵɵlistener("click", function SelectingLcaSocLibraryComponent_div_20_ng_template_3_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r13); const item_r7 = ctx.$implicit; const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.viewLcaDoc(item_r7); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 28);
    i0.ɵɵlistener("click", function SelectingLcaSocLibraryComponent_div_20_ng_template_3_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.deleteUnassignLCA(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r7.caseNumber, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r7.socCode, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r7.socTitle, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r7.documents);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r6.disabledControls);
} }
const _c1 = function (a0) { return [a0]; };
function SelectingLcaSocLibraryComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "p-table", 21);
    i0.ɵɵtemplate(2, SelectingLcaSocLibraryComponent_div_20_ng_template_2_Template, 11, 0, "ng-template", 22);
    i0.ɵɵtemplate(3, SelectingLcaSocLibraryComponent_div_20_ng_template_3_Template, 12, 5, "ng-template", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", i0.ɵɵpureFunction1(1, _c1, ctx_r3.assignedLcaList.lca));
} }
class SelectingLcaSocLibraryComponent extends BaseSelectingLcaSocLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, dialogService, router, appServicesLibraryService, primaryData) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, dialogService, router, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.dialogService = dialogService;
        this.router = router;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
        this.primaryData = primaryData !== undefined ? primaryData : {};
        // console.log("primaryData",this.primaryData)
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        super.loadInit();
    }
    ngAfterViewInit() {
        this.selectLCAForm = this.selectLCAForm;
        super.afterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
SelectingLcaSocLibraryComponent.ɵfac = function SelectingLcaSocLibraryComponent_Factory(t) { return new (t || SelectingLcaSocLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APISelectingLCA), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.DirtyFormGuard), i0.ɵɵdirectiveInject(i6.CacheCountryListService), i0.ɵɵdirectiveInject(i7.ReferenceLibraryService), i0.ɵɵdirectiveInject(i8.DialogService), i0.ɵɵdirectiveInject(i9.Router), i0.ɵɵdirectiveInject(i10.AppServicesLibraryService), i0.ɵɵdirectiveInject('primaryData', 8)); };
SelectingLcaSocLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SelectingLcaSocLibraryComponent, selectors: [["lib-selecting-lca-soc-library"]], viewQuery: function SelectingLcaSocLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectLCAForm = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 28, vars: 9, consts: [[1, "row", "d-flex", "align-items-center"], [1, "col-md-9", "step-title", "pb-3"], [3, "ngSubmit"], ["selectLCAForm", "ngForm"], [1, "row", "col-md-12"], [1, "col-6", "pl-0", "pr-0", "form-group", "processing-dropdown"], [1, "label-cls", "required", "row"], ["appendTo", "body", "name", "selectedLcaCode", "optionValue", "lcaId", "optionLabel", "caseNumber", "placeholder", "Select Group Code", "required", "", 3, "options", "filter", "ngModel", "disabled", "ngModelChange"], ["selectedLcaCodeVar", "ngModel"], ["pTemplate", "item"], [1, "row", "col-md-12", "align-items-center", "mb-4", "registerLCA"], ["href", "javascript:void(0);", 3, "click"], ["class", "col-12 pr-0", 4, "ngIf"], [1, "row", "pt-4"], [1, "col-md-4", "pt-4", "decision-check"], ["value", "Notify Beneficiary", "binary", "true", "name", "isBenNotifyLcaLinkPet", "label", "Notify Beneficiary", 3, "ngModel", "disabled", "ngModelChange"], [1, "row", "pt-3"], [1, "col-md-12", "form-group", "pb-2"], ["pButton", "", "type", "submit", "label", "Assign", 3, "ngClass", "disabled"], [1, "p-d-flex", "p-ai-center"], [1, "col-12", "pr-0"], [1, "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["colspan", "2"], [2, "text-align", "center"], [4, "ngFor", "ngForOf"], ["type", "button", "pButton", "", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "click"], ["type", "button", "pButton", "", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], ["style", "font-weight: normal;", 4, "ngIf"], [2, "font-weight", "normal"]], template: function SelectingLcaSocLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h6");
        i0.ɵɵelementStart(3, "b");
        i0.ɵɵtext(4, "Select LCA to link to petition ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "form", 2, 3);
        i0.ɵɵlistener("ngSubmit", function SelectingLcaSocLibraryComponent_Template_form_ngSubmit_5_listener() { return ctx.postAssignLca(); });
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "label", 6);
        i0.ɵɵtext(10, "Approved LCA List");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "p-dropdown", 7, 8);
        i0.ɵɵlistener("ngModelChange", function SelectingLcaSocLibraryComponent_Template_p_dropdown_ngModelChange_11_listener($event) { return ctx.selectedLcaCode = $event; });
        i0.ɵɵtemplate(13, SelectingLcaSocLibraryComponent_ng_template_13_Template, 3, 2, "ng-template", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 10);
        i0.ɵɵelementStart(15, "span");
        i0.ɵɵelementStart(16, "small");
        i0.ɵɵtext(17, "Enter ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "a", 11);
        i0.ɵɵlistener("click", function SelectingLcaSocLibraryComponent_Template_a_click_18_listener() { return ctx.createNewLCA(); });
        i0.ɵɵtext(19, " Registered/Approved LCA Details ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, SelectingLcaSocLibraryComponent_div_20_Template, 4, 3, "div", 12);
        i0.ɵɵelementStart(21, "div", 13);
        i0.ɵɵelementStart(22, "div", 14);
        i0.ɵɵelementStart(23, "p-checkbox", 15);
        i0.ɵɵlistener("ngModelChange", function SelectingLcaSocLibraryComponent_Template_p_checkbox_ngModelChange_23_listener($event) { return ctx.isBenNotifyLcaLinkPet = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(24, "p-divider");
        i0.ɵɵelementStart(25, "div", 16);
        i0.ɵɵelementStart(26, "div", 17);
        i0.ɵɵelement(27, "button", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(6);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("options", ctx.lcaList)("filter", false)("ngModel", ctx.selectedLcaCode)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.assignedLcaList == null ? null : ctx.assignedLcaList.lca);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.isBenNotifyLcaLinkPet)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", _r0.invalid || ctx.disabledControls ? "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-success_disabled btn-un" : "btn-success button-width-icon-left pl-4 pr-4 mr-3 btn-un")("disabled", _r0.invalid || ctx.disabledControls);
    } }, directives: [i11.ɵangular_packages_forms_forms_ba, i11.NgControlStatusGroup, i11.NgForm, i12.Dropdown, i11.RequiredValidator, i11.NgControlStatus, i11.NgModel, i13.PrimeTemplate, i14.NgIf, i15.Checkbox, i16.Divider, i17.ButtonDirective, i14.NgClass, i18.Table, i14.NgForOf, i19.Tooltip], styles: [".recommendedCode[_ngcontent-%COMP%]{background-color:#eff5fd;padding:20px 10px}.recommendedCode[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-size:18px;font-weight:500;color:#7b7c7e}.recommendedCode[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{font-size:35px;font-weight:500;color:#7b7c7e}.recommendedCode[_ngcontent-%COMP%]   .btn-un[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:18px;text-align:center;padding:10px}.recommendedCode[_ngcontent-%COMP%]   .addList[_ngcontent-%COMP%]{font-size:18px;font-weight:500;color:#7b7c7e}.recommendedCode[_ngcontent-%COMP%]   .addDesc[_ngcontent-%COMP%]{font-size:14px}.codes[_ngcontent-%COMP%]   .recom-label[_ngcontent-%COMP%]   .label-radiobutton-label[_ngcontent-%COMP%]{font-weight:500;font-size:15px}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;color:#4d4f5c;font-style:normal;font-variant:normal;font-weight:700}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:15px 10px!important;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{color:#4d4848;border-top:none!important}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 8px!important;color:#75777a}.pa-table[_ngcontent-%COMP%]   td.imagilityFlagIcon[_ngcontent-%COMP%]{padding:8px 0!important;border-right:none!important;text-align:center}.pa-table[_ngcontent-%COMP%]   td.imagilityFlagIcon[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:22px}.pa-table[_ngcontent-%COMP%]   td.imagilityFlagIcon[_ngcontent-%COMP%]   .flag-text[_ngcontent-%COMP%]{color:#2c2c2c;font-size:14px;padding:5px 10px}.table-btn[_ngcontent-%COMP%]{text-align:center}.main-body[_ngcontent-%COMP%]{height:calc(80vh - 216px);width:100%;overflow:auto;padding-right:10px;overflow-x:hidden}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 22px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 16px/22px Source Sans Pro}.step-title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#4d4848;font:normal normal 700 18px/31px Source Sans Pro}.label-cls[_ngcontent-%COMP%]{font:normal normal normal 14px/20px Source Sans Pro!important;color:#4a4a4a!important}.registerLCA[_ngcontent-%COMP%]{font:normal normal normal 16px/31px Source Sans Pro!important}.registerLCA[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#4d4848!important;margin-top:-5px!important}.registerLCA[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#0a7bb8!important;text-decoration:none!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectingLcaSocLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-selecting-lca-soc-library',
                templateUrl: 'selecting-lca-soc-library.component.html',
                styleUrls: ['selecting-lca-soc-library.component.scss'],
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APISelectingLCA }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }, { type: i6.CacheCountryListService }, { type: i7.ReferenceLibraryService }, { type: i8.DialogService }, { type: i9.Router }, { type: i10.AppServicesLibraryService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: ['primaryData']
            }] }]; }, { primaryData: [{
            type: Input
        }], selectLCAForm: [{
            type: ViewChild,
            args: ['selectLCAForm', { static: true }]
        }], onDialogClose: [{
            type: Output
        }] }); })();

class SelectingLcaSocLibraryModule {
}
SelectingLcaSocLibraryModule.ɵfac = function SelectingLcaSocLibraryModule_Factory(t) { return new (t || SelectingLcaSocLibraryModule)(); };
SelectingLcaSocLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: SelectingLcaSocLibraryModule });
SelectingLcaSocLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SelectingLcaSocLibraryModule, { declarations: [SelectingLcaSocLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule], exports: [SelectingLcaSocLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectingLcaSocLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectingLcaSocLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule
                ],
                exports: [SelectingLcaSocLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of selecting-lca-soc-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SelectingLcaSocLibraryComponent, SelectingLcaSocLibraryModule, SelectingLcaSocLibraryService };
//# sourceMappingURL=selecting-lca-soc-library.js.map
